import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`For support, Please open a ticket in the support forum`}</p>
    <pre><code parentName="pre" {...{}}>{`https://redqsupport.ticksy.com/

`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`There are some basic requirements for our application so that support team can help you quick such as,`}</p>
    </blockquote>
    <ol>
      <li parentName="ol">{`Asking queries regarding feature that is already implemented in the application`}</li>
      <li parentName="ol">{`Following recommended configuration, environments & server which you need to met first before you proceed with installation, deployment in your server to receive support.`}</li>
      <li parentName="ol">{`Support query need to be within Envato item support policy. (`}<a parentName="li" {...{
          "href": "https://themeforest.net/page/item_support_policy"
        }}>{`https://themeforest.net/page/item_support_policy`}</a>{`)`}</li>
      <li parentName="ol">{`You should maintain only one support ticket at a time. Creating multiple ticket can cause unexpected delays.`}</li>
      <li parentName="ol">{`Ticket should provide as much details as possible related to the issue such as screenshot, video explanation, access, how to reproduce, environments, if any changes or customisations are made etc`}</li>
    </ol>
    <blockquote>
      <p parentName="blockquote">{`During working days our ticket response can take 24 hours to 48 hours depending on the volume of tickets pending prior to your ticket . We follow Envato Item support policy `}<a parentName="p" {...{
          "href": "https://themeforest.net/page/item_support_policy"
        }}>{`https://themeforest.net/page/item_support_policy`}</a>{` to provide standard support for our items`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      